

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 10"}, rest), ["\n  ", h('g', {"fill":"currentColor","fill-rule":"evenodd"}, ["\n    ", h('path', {"d":"M.304 9.693a1.054 1.054 0 0 1 0-1.481L8.214.304a1.055 1.055 0 0 1 1.482 0 1.054 1.054 0 0 1 0 1.48l-7.91 7.909c-.196.21-.476.307-.741.307-.266 0-.531-.098-.741-.307Z"}, []), "\n    ", h('path', {"d":"M8.215 9.693.304 1.785a1.054 1.054 0 0 1 0-1.481 1.055 1.055 0 0 1 1.481 0l7.911 7.908a1.054 1.054 0 0 1 0 1.48c-.21.21-.475.308-.74.308-.266 0-.532-.098-.741-.307Z"}, []), "\n  "]), "\n"]);
};

        